{
    "NavigationAll": "Tudo",
    "NavigationReporting": "Comunicando",
    "NavigationAdministration": "Administração",
    "NavigationProvisioning": "Aprovisionamento",
    "NavigationDevices": "Dispositivos",
    "NavigationEndpoints": "Dispositivos",
    "NavigationTrunking": "Entroncamento",
    "NavigationHospitality": "Hotelaria",
    "NavigationTrunkgateways": "Gateways de trunk",
    "NavigationVoicemailservices": "Serviços de correio de voz",
    "NavigationConferencedevices": "Dispositivos de conferência",
    "NavigationAgents": "Agentes",
    "NavigationDirectory": "Diretório",
    "NavigationCodes": "Códigos",
    "NavigationPartitions": "Partições",
    "NavigationTelephonyservers": "Servidores de telefonia",
    "NavigationCmenvironments": "Ambientes de gestão central",
    "NavigationApplicationusers": "Utilizadores da aplicação",
    "NavigationOmnichannel": "Omnicanal",
    "NavigationRecording": "Gravação",
    "NavigationMessages": "Mensagens",
    "NavigationDatabase": "Base de dados",
    "NavigationStatustools": "Estado e ferramentas",
    "NavigationLicenses": "Licenças",
    "NavigationLogging": "Exploração madeireira",
    "NavigationLogmanagement": "gestão de logs",
    "NavigationAudittrail": "Trilha de auditoria",
    "NavigationTelephonemodulestatus": "Estado do Módulo de Telefonia",
    "NavigationOmnichannelmodulestatus": "Estado do Omnicanal",
    "NavigationCallcontrol": "controlo de chamadas",
    "NavigationServerstatus": "Estado do servidor",
    "NavigationNewAnalytics": "Adicionar empresa corporativa",
    "NAME": "LanguageMainNavigation",
    "InsightsHub": "Conhecimentos",
    "Presence": "Presença",
    "NavigationUserManagement": "Gestão de utilizadores",
    "NavigationManageUsersDevice": "Gerir utilizadores",
    "NavigationEasyProvisioning": "Aprovisionamento fácil",
    "NavigationManageQueues": "Gerir filas"
}